import { render, staticRenderFns } from "./MetaPolicyModal.vue?vue&type=template&id=30be7971&scoped=true"
import script from "./MetaPolicyModal.vue?vue&type=script&lang=js"
export * from "./MetaPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./MetaPolicyModal.vue?vue&type=style&index=0&id=30be7971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be7971",
  null
  
)

export default component.exports